// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile_profile__3dzvr"};